import React, { useEffect, useRef, useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import './AdvancedFeaturesMenu.css';

interface AdvancedFeaturesMenuProps {
  timelineDriftOn: boolean;
  onToggleTimelineDrift: () => void;
  showMeetingsOn: boolean;
  onToggleShowMeetings: () => void;
}

const AdvancedFeaturesMenu: React.FC<AdvancedFeaturesMenuProps> = ({
  timelineDriftOn,
  onToggleTimelineDrift,
  showMeetingsOn,
  onToggleShowMeetings,
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const anyOn = timelineDriftOn || showMeetingsOn;

  return (
    <div className="pm-advanced-features" ref={rootRef}>
      <button
        type="button"
        className={`pm-advanced-features-btn${open || anyOn ? ' is-on' : ''}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <SlidersHorizontal size={13} strokeWidth={2.25} aria-hidden />
        <span>Advanced</span>
      </button>
      {open && (
        <div className="pm-advanced-features-menu" role="menu" aria-label="Advanced features">
          <button
            type="button"
            role="menuitemcheckbox"
            aria-checked={timelineDriftOn}
            className={`pm-advanced-features-item${timelineDriftOn ? ' is-on' : ''}`}
            onClick={() => {
              onToggleTimelineDrift();
              setOpen(false);
            }}
          >
            Timeline drift
          </button>
          <button
            type="button"
            role="menuitemcheckbox"
            aria-checked={showMeetingsOn}
            className={`pm-advanced-features-item${showMeetingsOn ? ' is-on' : ''}`}
            onClick={() => {
              onToggleShowMeetings();
              setOpen(false);
            }}
          >
            Show meetings
          </button>
        </div>
      )}
    </div>
  );
};

export default AdvancedFeaturesMenu;
